exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".vue-form-wizard .wizard-nav-pills>li>a{color:#d0d63a}.multiselect__option--highlight{background:#d0d63a!important}.is-danger .multiselect__tags{border-color:red}", ""]);

// exports
